import { Grid, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';

const AIHistoryIndividualPageDetails = ({ data }: { data: any }) => {
    const user = data?.user;
    return (
        <Grid
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: { xs: 'flex-start', md: 'flex-end' },
                gap: 2,
                flexDirection: { xs: 'column', md: 'row' },
            }}
        >
            <Grid
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography
                    sx={{
                        color: 'text.primary',
                        fontSize: '20px',
                    }}
                >
                    {moment(data?.createdAt).format('ll')}
                </Typography>
                <Grid sx={{ display: 'flex', gap: 3 }}>
                    {' '}
                    <Typography
                        sx={{
                            color: 'text.primary',
                        }}
                    >
                        User :{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            {' '}
                            {user?.firstName + ' ' + user?.lastName}
                        </span>
                    </Typography>
                    <Typography
                        sx={{
                            color: 'text.primary',
                        }}
                    >
                        Company :{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            {' '}
                            {data?.company}
                        </span>
                    </Typography>
                </Grid>
            </Grid>
            {data?.booking && (
                <Link
                    to={{
                        pathname: `/reservations/${data?.booking.moduleName
                            .replace(/ /g, '')
                            .toLowerCase()}/${data?.booking.id}`,
                    }}
                    style={{
                        textDecoration: 'none',
                    }}
                >
                    {' '}
                    <Grid
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 2,
                            cursor: 'pointer',
                        }}
                    >
                        <Typography
                            sx={{
                                color: 'text.primary',
                            }}
                        >
                            Experience:{' '}
                            <span style={{ fontWeight: 'bold' }}>
                                {' '}
                                {data?.booking.moduleName}
                            </span>
                        </Typography>
                        <Typography
                            sx={{
                                color: 'text.primary',
                            }}
                        >
                            Reservation Ref:{' '}
                            <span style={{ fontWeight: 'bold' }}>
                                {' '}
                                {data?.booking.id}
                            </span>
                        </Typography>
                    </Grid>
                </Link>
            )}
        </Grid>
    );
};

export default AIHistoryIndividualPageDetails;
